import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { DatahubSettings } from '../../containers/DatahubSettings.container';

import Box from 'Common/Box/Box';
import DatahubAPI from '../../api/datahub.api';
import LogList from '../log-list/LogList';

import type { RootState } from '../../types/state.types';

import './SettingsDatahubLogsStyle.css';

export const SettingsDatahubLogs: React.FC = () => {
  const subUrl = useSelector((state: RootState) => state.subscription.url);
  const token = useSelector((state: RootState) => state.subscription.token);

  const [logs, setLogs] = useState([]);

  useEffect(() => {
    const getLogs = async () => {
      const logs = await DatahubAPI.getLogs({
        subUrl,
        token,
      });

      setLogs(logs);
    };

    if (token) {
      getLogs();
    }
  }, [token]);

  return (
    <DatahubSettings>
      <main className="scrollArea">
        <div className="settings-datahub-logs">
          <div className="settings-datahub-logs__list">
            <Box>
              <Box.Header>
                <Box.Title>Download logs</Box.Title>
              </Box.Header>
              <Box.Content>
                <LogList logs={logs} subUrl={subUrl} token={token} />
              </Box.Content>
            </Box>
          </div>
        </div>
      </main>
    </DatahubSettings>
  );
};
